// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BEBaseElement } from './BEBaseElement';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 参数 实体类
 * 参数
 */
export abstract class MDParameter extends BEBaseElement {
  /** 数据类型 : 数据类型 */
  private _dataType: EnumDataType;

  /** 设置：数据类型 */
  public get dataType() {
    return this._dataType;
  }

  /** 获取：数据类型 */
  public set dataType(value: EnumDataType) {
    this._dataType = value;
  }

  /** 引用类型 : 引用类型，当数据类型为引用的时候有效 */
  private _referenceType: string;

  /** 设置：引用类型 */
  public get referenceType() {
    return this._referenceType;
  }

  /** 获取：引用类型 */
  public set referenceType(value: string) {
    this._referenceType = value;
  }

  /** 是否是集合 : 是否是集合，集合时DataType使用内联类型 */
  private _isCollection: boolean;

  /** 设置：是否是集合 */
  public get isCollection() {
    return this._isCollection;
  }

  /** 获取：是否是集合 */
  public set isCollection(value: boolean) {
    this._isCollection = value;
  }

  /** 缺省值 : 缺省值 */
  private _defaultValue: string;

  /** 设置：缺省值 */
  public get defaultValue() {
    return this._defaultValue;
  }

  /** 获取：缺省值 */
  public set defaultValue(value: string) {
    this._defaultValue = value;
  }

  /** 是否校验 : 是否对参数进行校验 */
  private _isValidate: boolean;

  /** 设置：是否校验 */
  public get isValidate() {
    return this._isValidate;
  }

  /** 获取：是否校验 */
  public set isValidate(value: boolean) {
    this._isValidate = value;
  }

  /** 校验正则表达式 : 校验正则表达式 */
  private _validateExpress: string;

  /** 设置：校验正则表达式 */
  public get validateExpress() {
    return this._validateExpress;
  }

  /** 获取：校验正则表达式 */
  public set validateExpress(value: string) {
    this._validateExpress = value;
  }

  /** 验证失败提示消息 : 验证失败提示消息 */
  private _errorMessage: string;

  /** 设置：验证失败提示消息 */
  public get errorMessage() {
    return this._errorMessage;
  }

  /** 获取：验证失败提示消息 */
  public set errorMessage(value: string) {
    this._errorMessage = value;
  }

  /** 最大值 : 参数允许的最大值（包含本身），不定义则不起效 */
  private _maxValue: string;

  /** 设置：最大值 */
  public get maxValue() {
    return this._maxValue;
  }

  /** 获取：最大值 */
  public set maxValue(value: string) {
    this._maxValue = value;
  }

  /** 最小值 : 参数允许的最小值（包含本身），不定义则不起效 */
  private _minValue: string;

  /** 设置：最小值 */
  public get minValue() {
    return this._minValue;
  }

  /** 获取：最小值 */
  public set minValue(value: string) {
    this._minValue = value;
  }

  constructor() {
    super();
    this._dataType = EnumDataType.String;
    this._referenceType = '';
    this._isCollection = false;
    this._defaultValue = '';
    this._isValidate = false;
    this._validateExpress = '';
    this._errorMessage = '';
    this._maxValue = '';
    this._minValue = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: MDParameter, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.dataType = element.dataType;
      this.referenceType = element.referenceType;
      this.isCollection = element.isCollection;
      this.defaultValue = element.defaultValue;
      this.isValidate = element.isValidate;
      this.validateExpress = element.validateExpress;
      this.errorMessage = element.errorMessage;
      this.maxValue = element.maxValue;
      this.minValue = element.minValue;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.dataType = json.DataType as EnumDataType;
    this.referenceType = json.ReferenceType;
    this.isCollection = json.IsCollection;
    this.defaultValue = json.DefaultValue;
    this.isValidate = json.IsValidate;
    this.validateExpress = json.ValidateExpress;
    this.errorMessage = json.ErrorMessage;
    this.maxValue = json.MaxValue;
    this.minValue = json.MinValue;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.DataType = this.dataType;
    json.ReferenceType = this.referenceType;
    json.IsCollection = this.isCollection;
    json.DefaultValue = this.defaultValue;
    json.IsValidate = this.isValidate;
    json.ValidateExpress = this.validateExpress;
    json.ErrorMessage = this.errorMessage;
    json.MaxValue = this.maxValue;
    json.MinValue = this.minValue;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('基本属性', 'dataType', '数据类型', EnumDataType.Reference, this.dataType, true, '数据类型', 'EnumDataType', 'PGRowEnumValue');
    context.addRow('基本属性', 'referenceType', '引用类型', EnumDataType.String, this.referenceType, true, '引用类型，当数据类型为引用的时候有效', '', 'PGRowDataTypeValue:all');
    context.addRow('基本属性', 'isCollection', '是否是集合', EnumDataType.Bool, this.isCollection, true, '是否是集合，集合时DataType使用内联类型', '', '');
    context.addRow('基本属性', 'defaultValue', '缺省值', EnumDataType.String, this.defaultValue, true, '缺省值', '', '');
    context.addRow('校验属性', 'isValidate', '是否校验', EnumDataType.Bool, this.isValidate, true, '是否对参数进行校验', '', '');
    context.addRow('校验属性', 'validateExpress', '校验正则表达式', EnumDataType.String, this.validateExpress, true, '校验正则表达式', '', '');
    context.addRow('校验属性', 'errorMessage', '验证失败提示消息', EnumDataType.String, this.errorMessage, true, '验证失败提示消息', '', '');
    context.addRow('校验属性', 'maxValue', '最大值', EnumDataType.String, this.maxValue, true, '参数允许的最大值（包含本身），不定义则不起效', '', '');
    context.addRow('校验属性', 'minValue', '最小值', EnumDataType.String, this.minValue, true, '参数允许的最小值（包含本身），不定义则不起效', '', '');
  }
}
